import { debugLogs } from 'utils/common';

/* eslint-disable import/no-extraneous-dependencies */
const litePlayerFnQueue = {};
let isLitePlayerReady = false;

let playerLoadTime = 0;
export const logPerformanceTime = label => {
  const currentTime = performance.now();

  const timeDiff = playerLoadTime
    ? ` | Diff ${((currentTime - playerLoadTime) / 1000).toFixed(2)} sec`
    : '';
  debugLogs(
    `Minitv | tag:${label} | ${(currentTime / 1000).toFixed(2)} sec${timeDiff}`,
    '',
  );
  playerLoadTime = currentTime;
};

export const processLitePlayerFnQueue = (id = 'minitv') => {
  try {
    litePlayerFnQueue[id] = litePlayerFnQueue[id] || [];
    litePlayerFnQueue[id].forEach(fn => fn());
    isLitePlayerReady = true;
    litePlayerFnQueue[id] = [];
  } catch (error) {
    console.error('Error processing player queue:', error);
  }
};

export const excuteAfterLitePlayerReady = (id = 'minitv', fn) => {
  try {
    if (isLitePlayerReady) {
      fn();
    } else {
      litePlayerFnQueue[id] = litePlayerFnQueue[id] || [];
      litePlayerFnQueue[id].push(fn);
      setTimeout(() => {
        if (!isLitePlayerReady) {
          processLitePlayerFnQueue(id);
          console.warn(
            'processLitePlayerFnQueue , Executing function after 5 seconds',
          );
        }
      }, 5000);
    }
  } catch (error) {
    fn();
  }
};
export const getApiKey = ({ isEtimes = false, isMobile = false } = {}) => {
  const apiKeyMap = {
    true: {
      true: 'toi371mweb5awm99g9o6',
      false: 'toi371web5awj999ou6',
    },
    false: {
      true: 'toimweb5t9tCpb7nb5q6jUb',
      false: 'toiweba5ec9705eb7ac2c984033e061',
    },
  };
  const apiKey = apiKeyMap[isEtimes][isMobile];
  return apiKey;
};

export const getPlayerUrl = (pageProps = {}) => {
  const apiKey = getApiKey(pageProps);
  const lastPart = pageProps.isFullPlayer ? '' : '.light';
  logPerformanceTime('Start Loading Player JS');
  // if (!__PROD__) {
  //   return `https://tvid.in/player/stg/4.0.2/cpl${lastPart}.js`;
  // }
  return `https://tvid.in/r/spl.${apiKey}${lastPart}.js`;
};
